import { styled } from "@patientmpower/spiro";

export const EmptyStateContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  height: "100%",
  paddingBottom: "30%",

  p: {
    fontFamily: "$openSans",
    fontSize: "$text-lg",
    fontWeight: 400,

    color: "$charcoal",
  },
});

export const AccordionTitleButton = styled("button", {
  all: "unset",

  textDecoration: "underline",

  fontSize: "$text-lg",
  lineHeight: "22px",
});
